// require('dotenv').config();

import { createApp } from "vue";
import App from "./App.vue";
import router from "./router"; // Import router here
import { createPinia } from "pinia";
import "vuetify/styles";
import { createVuetify } from "vuetify";
import colors from "vuetify/util/colors";

import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import "@mdi/font/css/materialdesignicons.css";
import { aliases, mdi } from "vuetify/iconsets/mdi";
import "./firebaseConfig";
// 💡 Import your auth store
import { useAuthStore } from "./stores/auth";
import { VFileUpload } from "vuetify/labs/VFileUpload"; // VFileUpload is typically a component, not a global plugin for Vuetify setup
import VueSweetalert2 from "vue-sweetalert2";
import "sweetalert2/dist/sweetalert2.min.css";
import "../style/font.css";
import piniaPluginPersistedstate from "pinia-plugin-persistedstate";
//DATE____________________
import { VDateInput } from "vuetify/labs/VDateInput";

const vuetify = createVuetify({
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        dark: false, // 💡 Explicitly set dark to false
      },
    },
  },
  components: {
    ...components,
    VFileUpload,
    VDateInput, // Keep this if you're using VFileUpload directly as a component
  },
  directives,
  icons: {
    defaultSet: "mdi",
    aliases,
    sets: {
      mdi,
    },
  },
});

const pinia = createPinia();
const app = createApp(App);
app.use(VueSweetalert2);
app.use(pinia);
pinia.use(piniaPluginPersistedstate);
app.use(vuetify);

// 🚀 Initialize authentication state BEFORE mounting the app and applying the router
// Ensure authStore.initializeAuth() returns a Promise that resolves when the auth state is stable.
const authStore = useAuthStore();
authStore.initializeAuth().then(() => {
  app.use(router); // 💡
  app.mount("#app");
});
